"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgChemicalOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.18 23.48L20 13.67V4h2V2H10v2h2v9.67l-7.21 9.81A4.1 4.1 0 008.09 30h15.79a4.1 4.1 0 003.3-6.52zM14 14.33V4h4v10.33L20.68 18h-9.39zm11.75 12.52A2.06 2.06 0 0123.88 28H8.09a2.1 2.1 0 01-1.69-3.34L9.82 20h12.33l3.42 4.66a2.07 2.07 0 01.18 2.19z" })));
}
exports.default = SvgChemicalOutline;
//# sourceMappingURL=ChemicalOutline.js.map